import ConsoleBillContainer from "components/Console/Bill/ConsoleBill.containerNew";

const ConsoleBillPage = () => {
  return <ConsoleBillContainer />;
};

export default ConsoleBillPage;
